import * as commonConst from '../common/constants';
import * as eipConst from './constants';
import * as eipApis from '../../services/apis/eip';
import Vue from 'vue';
export default {
    [eipConst.calcEipPrice](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, eipApis.calcEipPrice);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [eipConst.updateBandWidth](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, eipApis.updateBandWidth);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    }
}